<template>
  <section class="viewsrhqyBaseManagecomponents_serviceModal">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="880px"
      @close="onResetForm"
    >
      <div class="pr-20">
        <el-form ref="form" :model="form" label-width="150px" :rules="rules">
          <el-form-item label="基地">
            {{ baseInfo.com_name }}
          </el-form-item>
          <el-form-item label="预约业务" prop="pids">
            <tableSelector
              :multiple="false"
              title="选择预约业务"
              v-model="form.pids"
              :rows.sync="form.business"
              url="/api/queue/admin/query_business"
              :params="{
                is_parent: 0,
                state: 1,
                keyword: ''
              }"
              :columns="businessColumns"
            >
              <template slot="content">
                <div>
                  <div v-for="item in form.business" :key="item.id">
                    {{ item.name }}
                  </div>
                </div>
              </template>
              <el-link type="primary" :underline="false">选择业务类型</el-link>
            </tableSelector>
          </el-form-item>
          <el-form-item label="车辆业务类型" prop="name">
            <el-input
              v-model.trim="form.name"
              placeholder="请输入车辆业务类型"
            ></el-input>
          </el-form-item>
          <el-form-item label="车辆类型代码" prop="code">
            <el-input
              v-model.trim="form.code"
              placeholder="请输入车辆类型代码"
            ></el-input>
          </el-form-item>
          <!-- 无车辆业务环保权限时，隐藏完整表单项和校验说明。 -->
          <el-form-item v-if="canManageVehicleEmission" label="环保排放校验" prop="emission_limit">
            <el-radio-group v-model="form.emission_limit">
              <el-radio :label="1">开启</el-radio>
              <el-radio :label="0">关闭</el-radio>
            </el-radio-group>
            <div class="text-xs text-gray-500 mt-2">
              总开关开启后，选择此车辆业务类型时校验车辆环保排放；免校验账号除外。
            </div>
          </el-form-item>
          <el-form-item label="是否需要SAP校验" prop="is_sap_check">
            <el-checkbox
              v-model="form.is_sap_check"
              :true-label="1"
              :false-label="0"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="是否需要送货单号" prop="is_delivery_code">
            <el-checkbox
              v-model="form.is_delivery_code"
              :true-label="1"
              :false-label="0"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="需要业务授权" prop="is_auth">
            <el-checkbox
              v-model="form.is_auth"
              :true-label="1"
              :false-label="0"
            ></el-checkbox>
          </el-form-item>
          <el-form-item label="允许先卸后取样" prop="allow_unload_before_sampling">
            <el-radio-group
              v-model="form.allow_unload_before_sampling"
              :disabled="!allowUnloadBeforeSamplingEditable"
            >
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
            <div class="text-xs text-gray-500 mt-2">
              <span v-if="allowUnloadBeforeSamplingEditable">
                开启后，车辆进厂仍先进入待取样，但允许在未取样时直接完成卸货，后续再补录取样事实。
              </span>
              <span v-else>
                仅当预约业务的订单类型为化辅 NB 时，才允许配置“先卸后取样”，其他业务固定为否。
              </span>
            </div>
          </el-form-item>
          <el-form-item label="供货类型" prop="supply_type">
            <multiDataList
              v-model="form.supply_type"
              :itemProps="supplyTypeOption"
            />
          </el-form-item>
          <el-form-item label="车辆类型控制" prop="note">
            <el-select
              clearable
              v-model="form.note"
              placeholder="请选择车辆类型控制"
              multiple
            >
              <el-option
                v-for="item in vehicleTypes"
                :key="item.id"
                :label="item.name"
                :value="item.name"
              />
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onOk">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import multiDataList from "@/components/multiDataList/index.vue";
import tableSelector from "@/components/tableSelector/index.vue";
import { cloneDeep } from "lodash";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      visible: false,
      supplyTypeOption: {
        code: {
          placeholder: "请输入编码"
        },
        name: {
          placeholder: "请输入名称"
        }
      },
      businessColumns: [
        { label: "预约业务名称", prop: "name" },
        {
          label: "业务类型",
          prop: "type",
          formatData: row => {
            return row.type == 11
              ? "送货业务"
              : row.type == 12
              ? "提货业务"
              : "--";
          }
        },
        {
          label: "订单类型",
          prop: "order_type",
          formatData: row => {
            return row.order_type || "--";
          }
        },
        {
          label: "进厂门岗",
          prop: "info_door_info",
          formatData: row => {
            return row.info_door_info.map(item => item.name).join("、");
          }
        },
        {
          label: "出厂门岗",
          prop: "out_door_info",
          formatData: row => {
            return row.out_door_info.map(item => item.name).join("、");
          }
        }
      ],
      form: {
        id: 0,
        name: "",
        code: "",
        type: "",
        category: "",
        pid: "",
        pids: [],
        business: [],
        p_order_type: "",
        user_list: "",
        auto_auth_units: "",
        note: [],
        enable_loadometer: "",
        car_tag: "",
        is_sap_check: 0,
        is_delivery_code: 0,
        is_auth: 0,
        emission_limit: 0,
        allow_unload_before_sampling: 0,
        supply_type: []
      },
      rules: {
        pids: [
          {
            required: true,
            message: "请选择预约业务",
            trigger: "type",
            type: "array"
          }
        ],
        name: [
          { required: true, message: "请输入车辆业务类型名称", trigger: "blur" }
        ],
        code: [
          { required: true, message: "请输入车辆类型代码", trigger: "blur" }
        ],
        allow_unload_before_sampling: [
          { required: true, message: "请选择是否允许先卸后取样", trigger: "change" }
        ]
      },
      info_doors: [],
      out_doors: []
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "vehicleTypes"]),
    title() {
      return this.form.id ? "修改车辆业务类型" : "新增车辆业务类型";
    },
    selectedParentBusiness() {
      return Array.isArray(this.form.business) && this.form.business.length
        ? this.form.business[0]
        : null;
    },
    selectedParentOrderType() {
      return (
        (this.selectedParentBusiness && this.selectedParentBusiness.order_type) ||
        this.form.p_order_type ||
        ""
      );
    },
    isNbParentBusiness() {
      return String(this.selectedParentOrderType).toUpperCase() === "NB";
    },
    allowUnloadBeforeSamplingEditable() {
      return this.isNbParentBusiness;
    },
    canManageVehicleEmission() {
      const keys = this.$store.state.privilegeConfig.keys || [];
      return keys.includes("c-base-mp-carBusiness-emission");
    }
  },
  watch: {
    selectedParentOrderType() {
      this.syncAllowUnloadBeforeSamplingState();
    }
  },
  components: {
    multiDataList,
    tableSelector
  },
  methods: {
    openModal(row) {
      this.visible = true;
      this.$nextTick(() => {
        if (row) {
          let newData = {};
          Object.keys(row).map(key => {
            if (Array.isArray(row[key]) && row[key].length === 0) {
              if (key === "supply_type") {
                newData[key] = [];
              } else {
                newData[key] = "";
              }
            } else {
              if (key === "pid") {
                newData["pids"] = [row[key]];
                newData["business"] = [
                  { id: row[key], name: row.p_name, order_type: row.p_order_type || "" }
                ];
                newData["p_order_type"] = row.p_order_type || "";
              } else if (key === "note") {
                // 将英文逗号隔开的字符串转换为数组
                newData[key] = row[key] ? row[key].split(",") : [];
              } else if (key === "allow_unload_before_sampling") {
                // 关键步骤：统一转成数字单选值，避免接口回传字符串时单选框不回显。
                newData[key] = Number(row[key]) === 1 ? 1 : 0;
              } else if (key === "emission_limit") {
                newData[key] = Number(row[key]) === 1 ? 1 : 0;
              } else {
                newData[key] = row[key];
              }
            }
          });
          this.form = Object.assign(this.form, cloneDeep(newData));
          this.syncAllowUnloadBeforeSamplingState();
        } else {
          this.$set(this.form, "emission_limit", 0);
        }
      });
    },
    onOk() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const url = "/api/queue/admin/save_business";
          this.$common
            .http({
              url,
              data: this.buildSavePayload(this.form),
              contentType: "application/json"
            })
            .then(() => {
              this.$message.success(`${this.form.id ? "修改" : "添加"}成功`);
              this.visible = false;
              this.$emit("ok");
            });
        }
      });
    },
    onResetForm() {
      Object.keys(this.form).map(key => {
        if (["business", "pids", "supply_type"].includes(key)) {
          this.$set(this.form, key, []);
        } else if (key === "emission_limit") {
          this.$set(this.form, key, 0);
        } else {
          this.$set(this.form, key, null);
        }
      });
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 关键步骤：只有父级预约业务订单类型为化辅 NB 时，车辆业务类型才允许开启“先卸后取样”。
    syncAllowUnloadBeforeSamplingState() {
      if (!this.isNbParentBusiness) {
        this.$set(this.form, "allow_unload_before_sampling", 0);
      }
    },
    // 关键步骤：子业务保存时只提交后端实际需要的字段，避免把查询回来的父业务展示字段原样带回去。
    buildSavePayload(form) {
      // 关键步骤：新增子业务时优先沿用已选父业务的类型和分类，减少空值请求直接打到后端。
      const selectedBusiness = Array.isArray(form.business) && form.business.length
        ? form.business[0]
        : null;
      const payload = {
        id: form.id || 0,
        name: form.name,
        code: form.code || "",
        type: form.type || (selectedBusiness && selectedBusiness.type) || "",
        category: form.category || (selectedBusiness && selectedBusiness.category) || "",
        pid: form.pids[0],
        user_list: form.user_list || "",
        auto_auth_units: form.auto_auth_units || "",
        enable_loadometer: form.enable_loadometer,
        car_tag: form.car_tag || "",
        is_sap_check: form.is_sap_check || 0,
        is_delivery_code: form.is_delivery_code || 0,
        is_auth: form.is_auth || 0,
        allow_unload_before_sampling:
          this.allowUnloadBeforeSamplingEditable &&
          Number(form.allow_unload_before_sampling) === 1
            ? 1
            : 0,
        is_sampling: 1,
        supply_type: form.supply_type || [],
        // 将数组转换为英文逗号隔开的字符串，兼容后端原有存储格式。
        note: Array.isArray(form.note) ? form.note.join(",") : form.note || ""
      };
      if (this.canManageVehicleEmission) {
        payload.emission_limit = Number(form.emission_limit) === 1 ? 1 : 0;
      }
      return payload;
    }
  }
};
</script>
